export const LIST_PREVIEW_NOTIFICATIONS = 'LIST_PREVIEW_NOTIFICATIONS';
export const LIST_NOTIFICATIONS = 'LIST_NOTIFICATIONS';
